import Reveal from "@/components/base/Reveal";
import { mapImage } from "@/mocks/ppcare";

export default function MapSection() {
  return (
    <section id="locations" className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <img
                src={mapImage}
                alt="Map with pins of Personal Physician Care locations"
                className="h-64 w-full object-cover md:h-[420px]"
              />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <p className="mb-3 font-label text-sm font-medium uppercase tracking-[0.2em] text-accent-600">
              Personal Physician Care, P.A.
            </p>
            <h2 className="text-2xl font-bold leading-tight text-foreground-950 md:text-4xl">
              Primary Care Conveniently <span className="text-accent-500">Located</span>
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              At Personal Physician Care, we prioritize patient convenience, providing exceptional
              healthcare services across multiple strategically located facilities. Our aim is to
              bring quality medical care closer to you, making it easier and more efficient to
              access routine check-ups, specialized treatments, and urgent care. With our diverse
              network of locations, you&apos;ll have convenient access to our expert medical team,
              reflecting our commitment to personalized and accessible healthcare. Experience peace
              of mind with our multiple convenient locations.
            </p>
            <a
              href="#locations"
              className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-map-pin-2-line" />
              Get Directions
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}